<template>
  <v-list-group v-model="active" class="white-icon">
    <v-list-tile slot="activator" class="list-tile">
      <v-list-tile-action class="list-icon">
        <v-icon color="#c4c9d0">{{ area.icono }}</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>{{ area.nombre }}</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-list-tile v-for="subarea in area.subareas" :key="subarea.nombre" @click="goRouteId(subarea.id)"
                 :class="{ pressed: $store.state.activeSubarea === subarea.id }">
      <v-tooltip right>
        <v-list-tile-content slot="activator">
          <v-list-tile-sub-title class="pl-4 text-truncate white--text">{{ subarea.nombre | limitSubtitle }}</v-list-tile-sub-title>
        </v-list-tile-content>
        <span>{{ subarea.nombre }}</span>
      </v-tooltip>
    </v-list-tile>
    <v-list-tile :class="{ pressed: $store.state.activeSubarea === 'contratos' }" v-if="area.showContracts" @click="goToContracts">
      <v-tooltip right>
        <v-list-tile-content slot="activator">
          <v-list-tile-sub-title class="pl-4 text-truncate white--text">Contratos</v-list-tile-sub-title>
        </v-list-tile-content>
        <span>Contratos</span>
      </v-tooltip>
    </v-list-tile>
    <v-list-tile :class="{ pressed: $store.state.activeSubarea === 'liquidaciones' }" v-if="area.showSettlements" @click="goToLiquidaciones">
      <v-tooltip right>
        <v-list-tile-content slot="activator">
          <v-list-tile-sub-title class="pl-4 text-truncate white--text">Liquidaciones</v-list-tile-sub-title>
        </v-list-tile-content>
        <span>Liquidaciones</span>
      </v-tooltip>
    </v-list-tile>

  </v-list-group>
</template>

<script>
export default {
  props: {
    area: Object
  },

  data () {
    return {
      active: false,
      subareaPressed: -1
    }
  },

  methods: {
    goToContracts () {
      this.$store.commit('setActiveSubarea', 'contratos')
      this.$router.push({ name: 'jugadores' })
    },
    goToLiquidaciones () {
      this.$store.commit('setActiveSubarea', 'liquidaciones')
      this.$router.push({ name: 'liquidacionestv' })
    },
    goRouteId (id) {
      if (this.$store.getters.hasFocusFicha) {
        this.$router.push({
          name: 'fichaClub',
          params: {
            idClub: this.$store.state.fichaId,
            idSubarea: id
          }
        })
      } else {
        this.$router.push({ name: 'ficha', params: { id: id } })
      }
    }
  },

  filters: {
    limitSubtitle: function (value) {
      if (value.length > 38) {
        return value.substr(0, 35) + '...'
      }
      return value
    }
  },

  created () {
    this.active = this.$store.state.activeArea === this.area.pk
  },

  watch: {
    '$store.state.activeArea' () {
      if (this.$store.state.activeArea !== -1) {
        this.active = this.$store.state.activeArea === this.area.pk
      }
    }
  }
}
</script>

<style scoped>
.list-tile {
  padding: 0.2em 0 0.2em 0;
  color: #d8d8d7;
}
.pressed {
  background-color: #355487;
  border-right: 0.2em solid #0BBAD9;
}
.list-icon {
  padding: 0 0 0 1.1em;
}
.white-icon i {
  color: #c4c9d0 !important;
}
</style>
